import { render } from "./App.vue?vue&type=template&id=1fc0af97"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1fc0af97&lang=css"

import exportComponent from "C:\\Users\\Antonio\\Desktop\\model-viewer-generator_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__